import { useQuery } from "@apollo/client/react";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { constantsData } from "@/data";
import { getReleaseMotionArtworksListQuery } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useReleaseMotionArtworksList = (releaseId) => {
    const dispatch = useDispatch();

    const { isAuthenticated } = useAuth0();

    const { t } = useTranslation();

    const { data, error, loading } = useQuery(getReleaseMotionArtworksListQuery, {
        skip: !isAuthenticated,
        variables: {
            where: {
                release: {
                    id: { equals: releaseId },
                },
            },
        },
    });

    useEffect(
        () => {
            if (error?.message === constantsData.failedToFetch && !loading) {
                displayErrorHandler(t("messages.networkFailure"), dispatch, openAlert);
            }
        },
        [error, data], // eslint-disable-line
    );

    return {
        count: data?.listMotionArt?.meta?.nodeCount,
        data: data?.listMotionArt?.posts,
        loading,
        page: data?.listMotionArt?.meta?.currentPage,
    };
};

export default useReleaseMotionArtworksList;
